import { Decoder, number, object, string } from '@mojotech/json-type-validation'

import { ArenaProblemElement } from '@/domain/entities/arena/arenaProblemElement'

export const arenaProblemElementDecoder: Decoder<ArenaProblemElement> = object({
  id: string(),
  serial: number(),
  problemId: string(),
  arenaId: string(),
  available: number(),
  name: string(),
  rate: number(),
  problemTimeLimit: number(),
  problemMemoryLimit: number()
})
